<template>
    <div class="top-app">
		<div class="header">
			<div class="w1200">
				<div class="top flexDiv">
					<div class="logoDiv flexDiv">
						<p class="logoBox"><a href="./index.html"><img src="../assets/img/logo.png" alt="logo"></a></p>
						<div class="mks"><span>机电与轨道车辆工程系</span><span>招生代码：5706</span></div>
					</div>
					<div class="sousuoDiv">
						<p class="inputBox flexDiv">
							<a href="http://www.swjtuhc.cn/" target="_blank">学院首页</a>
							<span @click="backtrack()"><img src="../assets/img/fh.png" alt=""></span>
						</p>
            <div class="inputDiv flexDiv">
            	<input type="text" placeholder="" id="search" v-model='SearchStr' @keyup.enter='Search'/>
            	<a href="javascript:;" @click.stop='Search'>搜索</a>
            </div>
					</div>
				</div>
			</div>
			<div class="daohang">
				<div class="w1200">
					<ul class="mulu flexDiv" id="navBox">
						<li v-for='item in menuListOne' :key='item.ID'>
						  <!-- <a v-if='item.Url.indexOf("http")==-1' :href="item.Url" class="topA" :class="[item.On?'on':'']">{{item.Name}}</a>
						  <router-link v-else :to="(item.Children.length==0?item.Url :item.Children[0].Url)" :key='CId' :class="[item.On?'on':'']" ><i></i> {{item.Name}}</router-link>
              <div v-if="item.Children.length>0" class="hideDiv">
                <p class="menuLogo"><img :src="item.Logo" alt=""></p>
                <dl class="menuDl">
                	<dd v-for="item2 in item.Children" :key="item2.ID">
                		<router-link v-if='item2.Url.indexOf("http")==-1' :to="item2.Url" :key='item2.ID' >{{item2.Name}}</router-link>
                		<a v-else :href="item2.Url">{{item2.Name}}</a>
                	</dd>
                </dl>
              </div> -->
              <div v-if="item.Children&&item.Children.length>0" class="HeadWrap-menu_div">
                  <!-- <router-link :to="item.Url? item.Url : item.Children[0].Url" :key="CId"
                    :class="[item.On ? 'on' : '']" >{{ item.Name }}</router-link> -->
                  <a v-if='item.Url.indexOf("http")==-1' :href="item.Url" class="topA" :class="[item.On?'on':'']">{{item.Name}}</a>
                  <router-link v-else :to="(item.Children.length==0?item.Url :item.Children[0].Url)" :key='CId' :class="[item.On?'on':'']" ><i></i> {{item.Name}}</router-link>
                  <div v-if="item.Children.length > 0" class="hideDiv">
                   <p class="menuLogo"><img :src="item.Logo" alt=""></p>
                    <dl class="menuDl">
                    	<dd v-for="item2 in item.Children" :key="item2.ID">
                    		<router-link v-if='item2.Url.indexOf("http")==-1' :to="item2.Url" :key='item2.ID' >{{item2.Name}}</router-link>
                    		<a v-else :href="item2.Url">{{item2.Name}}</a>
                    	</dd>
                    </dl>
                  </div>
                </div>
                <router-link v-else :to="item.Url">{{ item.Name }}</router-link>
					  </li>
					  <!-- <li><a href="http://www.hbqcxy.com/" target="_blank">学院首页</a></li> -->
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name:'top',
	data(){
		return{
			 menuList:[],
			 menuListOne:[],
			 CId:this.$route.query.CId,
			 SearchStr: null
		}
	},
	methods:{
		Search(){
			if(!this.SearchStr){
				alert('请输入查找关键字');
			}else{
				this.$router.push('./search.html?selText='+this.SearchStr)
			}
		},
    backtrack(){
      this.$router.go(-1)
    }
	},
	created(){
		this.menuList = this.Base.GetNavColumnsByDid();
		this.menuListOne = this.menuList.filter((ele)=>ele.FID == 0)
		this.menuListOne.forEach((r)=>{
			r.Children = this.menuList.filter((ele)=>ele.FID == r.ID)
		})
		this.menuListOne.unshift({Name:'首页',Url:'./index.html',On: true,Children:[]});
		// console.log(this.menuListOne,1)
		$(document).ready(function() {
			$('#navBox>li').hover(function() {
				$(this).children().find(".hideDiv").stop().slideToggle("slow");
			});
		});
	}
}
</script>

<style lang="less" scoped>
.top-app{
		background-color: #fff;
		z-index: 999;
		.header{
			z-index: 2;
			position: relative;
			width: 100%;
      height: 150px;
      box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.18);
			.top{
			    height: 107px;
			    align-items: center;
				.logoDiv{
          position: relative;
          margin-left: 30px;
					.logoBox{
            width: 435px;
            height: 67px;
					}
					.mks{
						margin-left: 40px;
						position: relative;
						&::before{
							content: '';
							width: 1px;
							height: 64px;
              background-color: #000000;
							position: absolute;
							left: -20px;
							top: 0;
						}
						span{
							display: block;
							&:first-child{
                margin-top: 12px;
								font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                line-height: 24px;
                letter-spacing: 5px;
                color: #0a589b;
							}
							&:last-child{
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 30px;
                letter-spacing: 1px;
                color: #005197;
							}
						}
					}
				}
				.sousuoDiv{
          position: relative;
					.inputBox{
            justify-content: flex-end;
						a{
              width: 101px;
              height: 24px;
              border-radius: 12px;
              background-color: #489be2;
              font-size: 14px;
              font-weight: bold;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 3px;
              color: #ffffff;
              text-align: center;
						}
            span{
              width: 24px;
              height: 24px;
              background-color: #489ae2;
              border-radius:50%;
              text-align: center;
              cursor: pointer;
              img{
                width: 17px;
                height: 11px;
              }
            }
          }
          .inputDiv{
            margin-top: 5px;
            position: relative;
            &::after{
              content: '';
              width: 1px;
              height: 19px;
              background-color: #489be2;
              position: absolute;
              right: 55px;
              top: 5px;
            }
            input{
              width: 132px;
              height: 26px;
              background-color: #edf7ff;
              border: solid 1px #489be2;
              opacity: 0.6;
              border-radius: 15px;
              padding-left: 20px;
              padding-right: 66px;
            }
            a{
              position: absolute;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 28px;
              letter-spacing: 2px;
              color: #489be2;
              right: 12px;
              top: 0;
            }
          }
				}
			}
			/*导航栏*/
			.daohang{
        height: 43px;
        position: relative;
        border-top: 1px solid #e2f2ff;
        box-sizing: border-box;
        .mulu {
          display: flex;
          justify-content: space-between;
          position: relative;
					li{
						display: block;
						flex: 1;
						height: 43px;
						text-align: center;
						position: relative;
            .HeadWrap-menu_div{
              &:hover::before{
                content: '';
                width: 27px;
                height: 16px;
                transition: all .4s;
                background-image: url(../assets/img/ico.png);
                position: absolute;
                top: 28px;
                left: 50px;
                z-index: 99;
              }
            }

						a{
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 3px;
              color: #000000;
              line-height: 43px;
              display: inline-block;
						}
            .hideDiv{
              display: none;
              width: 795px;
              height: 180px;
              background-color: #ffffff;
              box-shadow: 0px 0px 3px 0px rgba(0, 81, 151, 0.6);
              position: absolute;
              // left: -170px;
              margin-left: -132px;
              top: 42px;
              z-index: 11;
              &::before{
                content: '';
                width: 400px;
                height: 145px;
                background: url(../assets/img/bg1.png);
                position: absolute;
                z-index: 0;
                right: 0;
                bottom: 0;
              }
              .menuLogo{
                width: 230px;
                height: 140px;
                float: left;
                margin: 20px;
              }
              .menuDl{
                // float: right;
                display: flex;
                // justify-content: space-between;
                flex-wrap: wrap;
                margin-top: 34px;
                position: relative;

              	dd{
              		transition: all .4s;
                  position: relative;
                  text-align: center;
                  width: 110px;
                  margin-left: 40px;
                  margin-bottom: 12px;
                  a{
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 48px;
                    letter-spacing: 1px;
                    color: #000000;
                    display: block;
                    &::before{
                      content: '';
                      width: 8px;
                      height: 8px;
                      background-color: #005a99;
                      border-radius: 50%;
                      position: absolute;
                      left: 10px;
                      top: 20px;
                    }
                  }
              		&:hover{
              			a{
              				color: #005a99;
              			}
              		}
              	}
              }
            }
					}

          li:nth-child(6){
            .hideDiv{
              right: -300px;
            }
          }
          li:last-child{
            .hideDiv{
              right: 0;
            }
          }
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/top.vue